const FormItemsWrapper = ({ children }) => {
  return <div className="formItems__wrapper">{children}</div>;
};

export default FormItemsWrapper;
